// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --field-background-color: var(--base-20);
}

.TextField__content-f978e0 {
  display: block;
  padding: 14px 12px;
  position: relative;
  height: 52px;
  background-color: var(--field-background-color);
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
  border-color: transparent;
}

.TextField__content-f978e0:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  border-bottom: 2px solid transparent;
  border-bottom-color: inherit;
}

.TextField__focused-debc5f {
  border-color: var(--brand-secondary-40);
}

.TextField__success-ce0a48 .TextField__label-b95804,
.TextField__success-ce0a48 + .TextField__helper-text-f6675e {
  color: var(--success-30);
}

.TextField__success-ce0a48 {
  border-color: var(--success-30);
}

.TextField__error-dbbf31 .TextField__label-b95804,
.TextField__error-dbbf31 + .TextField__helper-text-f6675e {
  color: var(--danger-40);
}

.TextField__error-dbbf31 {
  border-color: var(--danger-40);
}

.TextField__disabled-b30614 .TextField__label-b95804 {
  color: var(--base-50);
}

.TextField__disabled-b30614,
.TextField__disabled-b30614 .TextField__input-b546e4::placeholder {
  color: var(--base-50);
}

.TextField__label-b95804 {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  z-index: 1;
  transform: translate(12px, 14px) scale(1);
  transform-origin: top left;
  pointer-events: none;
  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.TextField__label-b95804.TextField__labelOver-ae8c1e {
  z-index: 3;
}

.TextField__small-label-c495e2 {
  transform: translate(12px, 6px) scale(0.75);
}

.TextField__input-b546e4 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  background-color: var(--field-background-color);
  z-index: 1;
  box-sizing: border-box;
}

.TextField__resizer-d6f538 {
  display: flex;
  position: relative;
  height: 100%;
  max-width: 100%;
}

.TextField__placeholder-d80642 + .TextField__resizer-d6f538 {
  display: inline-flex;
}

.TextField__hidden_placeholder-ccfe9d {
  white-space: pre;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
  background-color: var(--field-background-color);
  opacity: 0;
}

.TextField__placeholder-d80642 {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  padding: 14px 12px 12px;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  pointer-events: none;
}

.TextField__placeholder-d80642.TextField__with-placeholder-label-a338e1 {
  padding-top: 20px;
}

.TextField__with-label-c2911b {
  padding-bottom: 4px;
}

.TextField__with-label-c2911b .TextField__input-b546e4 {
  padding: 8px 0 0;
  background-color: transparent;
}

.TextField__with-label-c2911b.TextField__with-placeholder-f4f660 .TextField__input-b546e4 {
  padding-bottom: 0;
  padding-top: 0;
  background-color: var(--field-background-color);
}

.TextField__helper-text-f6675e {
  height: 16px;
  font: var(--font-caption-2);
  letter-spacing: var(--font-spacing-caption-2);
  color: var(--base-80);
  margin-top: 4px;
  padding: 0 12px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/TextField/TextField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,+CAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,oCAAA;EACA,4BAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;;EAEE,wBAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;;EAEE,uBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;;EAEE,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EAEA,wBAAA;EACA,0CAAA;EACA,qBAAA;EAEA,UAAA;EACA,yCAAA;EACA,0BAAA;EACA,oBAAA;EACA,sGAAA;AADF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,2CAAA;AAFF;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,+CAAA;EACA,UAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAFF;;AAKA;EACE,oBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,+CAAA;EACA,UAAA;AAFF;;AAKA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,6BAAA;AAFF;;AAKA;EACE,iBAAA;EACA,cAAA;EACA,+CAAA;AAFF;;AAKA;EACE,YAAA;EACA,2BAAA;EACA,6CAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAFF","sourcesContent":[":root {\n  --field-background-color: var(--base-20);\n}\n\n.content {\n  display: block;\n  padding: 14px 12px;\n  position: relative;\n  height: 52px;\n  background-color: var(--field-background-color);\n  border-radius: 12px;\n  box-sizing: border-box;\n  overflow: hidden;\n  border-color: transparent;\n}\n\n.content:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  border-bottom: 2px solid transparent;\n  border-bottom-color: inherit;\n}\n\n.focused {\n  border-color: var(--brand-secondary-40);\n}\n\n.success .label,\n.success + .helper-text {\n  color: var(--success-30);\n}\n\n.success {\n  border-color: var(--success-30);\n}\n\n.error .label,\n.error + .helper-text {\n  color: var(--danger-40);\n}\n\n.error {\n  border-color: var(--danger-40);\n}\n\n.disabled .label {\n  color: var(--base-50);\n}\n\n.disabled,\n.disabled .input::placeholder {\n  color: var(--base-50);\n}\n\n.label {\n  position: absolute;\n  display: block;\n  top: 0;\n  left: 0;\n\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n\n  z-index: 1;\n  transform: translate(12px, 14px) scale(1);\n  transform-origin: top left;\n  pointer-events: none;\n  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,\n    transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n}\n\n.label.labelOver {\n  z-index: 3;\n}\n\n.small-label {\n  transform: translate(12px, 6px) scale(0.75);\n}\n\n.input {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  background-color: var(--field-background-color);\n  z-index: 1;\n  box-sizing: border-box;\n}\n\n.resizer {\n  display: flex;\n  position: relative;\n  height: 100%;\n  max-width: 100%;\n}\n\n.placeholder + .resizer {\n  display: inline-flex;\n}\n\n.hidden_placeholder {\n  white-space: pre;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n  background-color: var(--field-background-color);\n  opacity: 0;\n}\n\n.placeholder {\n  position: absolute;\n  left: 0;\n  top: 0;\n  display: block;\n  padding: 14px 12px 12px;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  pointer-events: none;\n}\n\n.placeholder.with-placeholder-label {\n  padding-top: 20px;\n}\n\n.with-label {\n  padding-bottom: 4px;\n}\n\n.with-label .input {\n  padding: 8px 0 0;\n  background-color: transparent;\n}\n\n.with-label.with-placeholder .input {\n  padding-bottom: 0;\n  padding-top: 0;\n  background-color: var(--field-background-color);\n}\n\n.helper-text {\n  height: 16px;\n  font: var(--font-caption-2);\n  letter-spacing: var(--font-spacing-caption-2);\n  color: var(--base-80);\n  margin-top: 4px;\n  padding: 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `TextField__content-f978e0`,
	"focused": `TextField__focused-debc5f`,
	"success": `TextField__success-ce0a48`,
	"label": `TextField__label-b95804`,
	"helper-text": `TextField__helper-text-f6675e`,
	"helperText": `TextField__helper-text-f6675e`,
	"error": `TextField__error-dbbf31`,
	"disabled": `TextField__disabled-b30614`,
	"input": `TextField__input-b546e4`,
	"labelOver": `TextField__labelOver-ae8c1e`,
	"small-label": `TextField__small-label-c495e2`,
	"smallLabel": `TextField__small-label-c495e2`,
	"resizer": `TextField__resizer-d6f538`,
	"placeholder": `TextField__placeholder-d80642`,
	"hidden_placeholder": `TextField__hidden_placeholder-ccfe9d`,
	"hiddenPlaceholder": `TextField__hidden_placeholder-ccfe9d`,
	"with-placeholder-label": `TextField__with-placeholder-label-a338e1`,
	"withPlaceholderLabel": `TextField__with-placeholder-label-a338e1`,
	"with-label": `TextField__with-label-c2911b`,
	"withLabel": `TextField__with-label-c2911b`,
	"with-placeholder": `TextField__with-placeholder-f4f660`,
	"withPlaceholder": `TextField__with-placeholder-f4f660`
};
module.exports = ___CSS_LOADER_EXPORT___;
